import Headroom from 'headroom.js'; // eslint-disable-line

let headroomInstance;

function unpinNavBar(element) {
	document.location.hash.length &&
		document.documentElement.scrollHeight !== document.documentElement.clientHeight &&
		element.classList.add('headroom--unpinned');
}

function initHeadroom(element) {
	headroomInstance = new Headroom(element, {
		offset: 10,
		tolerance: 10
	});

	if (!window.location.hash || document.readyState === 'complete') {
		headroomInstance.init();
	} else {
		document.onreadystatechange = () => {
			if (document.readyState === 'complete') {
				headroomInstance.init();
			}
		};
	}
}

export function applyHeadroom(element) {
	initHeadroom(element);
	unpinNavBar(element);
}

export const headroom = Object.create(Object.prototype, {
	instance: {
		get() {
			return headroomInstance;
		},
		configurable: false
	}
});
